import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onSave: '&',
        onClose: '&',
        copyFromOccurrence: '=',
        showCopyAllOption: '=',
        message: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'occurrence.Copy occurrence' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-success ng-binding ng-scope" ng-if="vm.message">{{ vm.message }}</div>
            <div class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.copyError">
                        <form-row-error></form-row-error>
                    </form-row>
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'course.Occurrence name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <div class="row">
                        <span class="label">{{ 'course.Copy associated employees and the version to the new occurrence' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li><input type="checkbox" ng-model="vm.copyParticipants" ng-click="vm.toggleCopyAllParticipants()"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.copyParticipants && vm.showCopyAllOption">
                        <span class="label">{{ 'course.Also copy the employees who have already passed or failed the course in the cancelled occurrence' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li><input type="checkbox" ng-model="vm.form.model.copyAllParticipants"></li>
                            </ul>
                        </div>
                    </div>
                </form-wrapper>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><a class="btn main" ng-click="vm.save()">{{ 'general.Save' | translate }}</a></li>
                <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($state, $translate, FormFactory, OccurrenceResource, OCCURRENCE_STATUS_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.OccurrenceResource = OccurrenceResource;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
    }

    $onInit () {
        this.copyParticipants = false;
        this.occurrence = new this.OccurrenceResource({
            courseId: this.copyFromOccurrence.courseId,
            courseVersionId: this.copyFromOccurrence.courseVersionId,
            siteId: this.copyFromOccurrence.siteId,
            status: this.OCCURRENCE_STATUS_ENUM.KEYS.UNPUBLISHED,
            isMarketplaceOccurrence: this.copyFromOccurrence.isMarketplaceOccurrence,
            hideFromMarketplaceList: this.copyFromOccurrence.hideFromMarketplaceList,
            isMarketplaceRegistrationDisabled: this.copyFromOccurrence.isMarketplaceRegistrationDisabled,
            isOptionalTargetsOccurrence: this.copyFromOccurrence.isOptionalTargetsOccurrence
        });
        this.form = this.FormFactory.create(this.occurrence, model => model.$save());
    }

    toggleCopyAllParticipants () {
        if (!this.copyParticipants) {
            this.form.model.copyAllParticipants = null;
        }
    }

    save () {
        this.copyError = false;
        this.message = false;
        if (this.copyParticipants) {
            this.form.model.copyFromOccurrenceId = this.copyFromOccurrence.id;
        }

        this.form.save()
            .then((model) => {
                this.occurrence = model;
                this.onClose();
                this.$state.go('authorized.courses.courses.edit.occurrence.edit.general', {
                    id: this.$state.params.id, occurrenceId: this.occurrence.id
                });
            })
            .catch(() => {
                if (this.form.errors.courseVersionId) {
                    this.copyError = this.$translate.instant('course.The version linked to the occurrence that is being copied is archived. Occurrence can not be copied');
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/copyFrom/index.js